const _excluded = ["label", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { ButtonGroup, Popper, Grow, Paper, ClickAwayListener } from '@material-ui/core';
import { Button } from "../Button";
import { WideArrowDownward } from "../../icons";
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
const useStyles = makeStyles({
  buttonGroup: {
    '& .MuiButtonGroup-groupedContainedHorizontal:not(:last-child)': {
      borderRight: '0px'
    },
    '& .MuiButtonGroup-groupedContainedHorizontal:focus-within': {
      boxShadow: 'none'
    }
  },
  popper: {
    zIndex: 1
  }
});
export function SplitButton(props) {
  const {
      label,
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const testId = props['data-testid'] || 'split-button';
  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const overrides = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ButtonGroup, {
    variant: "contained",
    ref: anchorRef,
    className: cn(overrides.buttonGroup)
  }, /*#__PURE__*/React.createElement(Button, _extends({}, rest, {
    "data-testid": "".concat(testId, "-main")
  }), label), /*#__PURE__*/React.createElement(Button, {
    onClick: handleToggle,
    "data-testid": "".concat(testId, "-arrow")
  }, /*#__PURE__*/React.createElement(WideArrowDownward, null))), /*#__PURE__*/React.createElement(Popper, {
    open: open,
    anchorEl: anchorRef.current,
    transition: true,
    disablePortal: true,
    className: cn(overrides.popper)
  }, _ref => {
    let {
      TransitionProps,
      placement
    } = _ref;
    return /*#__PURE__*/React.createElement(Grow, _extends({}, TransitionProps, {
      style: {
        transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
      }
    }), /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(ClickAwayListener, {
      onClickAway: handleClose
    }, children)));
  }));
}